import { useRouter } from 'next/router'
import React, { useCallback, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/toolbox-helper'

import useShowSocialDrawer from 'app/PelatihanMandiriPage/hooks/useShowSocialDrawer'
import { CustomErrorFallback } from 'components/ErrorBoundary'
import CLStandalone from 'app/PelatihanMandiriPage/pages/CLStandalone'

const ContextualizedLearningPage = () => {
  const router = useRouter()
  const [shareText, setShareText] = useState('')
  const { triggerShareDialog, Drawer } = useShowSocialDrawer({
    drawerTitle: 'Bagikan Referensi',
    shareText,
  })
  const handlePageLoaded = useCallback(
    (title?: string) => {
      setShareText(
        `Ibu/Bapak Guru, ada ${
          !!title ? `artikel "${title}"` : 'artikel'
        } di platform Merdeka Mengajar untuk jadi referensi. Silakan cek di tautan berikut: ${
          window.location.href
        }`
      )
    },
    [setShareText]
  )
  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <CustomErrorFallback
          error={error}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
    >
      <HeaderBar fixed borderless className="z-10 !shadow-header">
        <HeaderBarLeftAction
          icon={
            <Icon as="i" color="default">
              arrow_back
            </Icon>
          }
          onClick={() => historyUtils.backToApp(router.back)}
        />
        <HeaderBarRightAction onClick={triggerShareDialog}>
          <Icon>share</Icon>
        </HeaderBarRightAction>
      </HeaderBar>
      <CLStandalone onPageLoaded={handlePageLoaded} />
      <Drawer />
    </ErrorBoundary>
  )
}

ContextualizedLearningPage.layoutOpts = {
  hasHeader: false,
  className: 'bg-gray-10 mt-14',
}

export default ContextualizedLearningPage
